import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getActiveAssociateAffiliates } from '../view/HTTPService';

/**
 * /activeAssociateAffiliates - Lista de afiliados ativos associados.
 */
export default function ActiveAssociateAffiliatesPage() {
    return (
        <AffiliateList
            titleKey="msg.jkaActiveAssociateAffiliates"
            fetchAffiliates={getActiveAssociateAffiliates}
        />
    );
}
